module.exports = __webpack_public_path__ + "static/loop-de454c92e03b04cc27c94bed0d1816e9.jpg";